import * as constants from '../constants'

export const DEFAULT_STATE = {
  data: [],
  propertySearchListLookup: [],
  isSearchListLoading: false,
  total: null
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case constants.GET_PROPERTIES.FULFILLED:
      return { ...state, ...action.payload }
    case constants.GET_PROPERTY_SEARCH_LIST.ACTION: {
      return { ...state, isSearchListLoading: true }
    }
    case constants.GET_PROPERTY_SEARCH_LIST.FULFILLED: {
      return { ...state, propertySearchListLookup: action.payload?.data, isSearchListLoading: false }
    }
    case constants.GET_PROPERTY_SEARCH_LIST.REJECTED: {
      return { ...state, propertySearchListLookup: [], isSearchListLoading: false }
    }
    case constants.RESET_LIST_SEARCH_RESULTS.ACTION: {
      return { ...state, propertySearchListLookup: [], isSearchListLoading: false }
    }
    default:
      return state
  }
}
